export default {
  loading: false,
  macroStates: [],
  microStates: [],
};



// WEBPACK FOOTER //
// ./src/stores/order-status/states.js